import { GlobalState } from "little-state-machine";
import IAssignWhitespacePermissionsRequest from "interfaces/requests/IAssignWhitespacePermissionsRequest";

export const updateAssignWhitespacePermissionsRequest = (state: GlobalState, assignWhitespacePermissionsRequest : IAssignWhitespacePermissionsRequest) => ({
  ...state,
  assignWhitespacePermissionsRequest
});
